import { createFileRoute, useSearch } from "@tanstack/react-router";
import { z } from "zod";
import { ExportsPage } from "../components/exports/ExportsPage";

/** A project to export, chosen already when the page is opened from its settings. */
const exportsSearchSchema = z.object({ project: z.string().max(40).optional().catch(undefined) });

/** The person's exports (BUILD_SPEC §19.6). */
function ExportsRoute() {
  const search = useSearch({ from: "/admin/exports" });
  return <ExportsPage projectId={search.project} />;
}

export const Route = createFileRoute("/admin/exports")({
  validateSearch: exportsSearchSchema,
  component: ExportsRoute,
});
